<template>
  <ym-img class="education-column-rect-cover-component"
          :src="src"
          :alt="alt"
          :lazy="lazy"
  />
</template>

<script>
  import YmImg from '@/components/YmImg';

  export default {
    name: 'EducationColumnRectCover',
    components: {
      YmImg,
    },
    props: {
      src: String,
      alt: String,
      lazy: Boolean,
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .education-column-rect-cover-component {
    display: block;
    width: 100%;
    height: @education-column-rect-cover-height;
  }
</style>
